function RemoveTopic() {
}

module.exports = RemoveTopic;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/remove-topic/remove-topic.js
// module id = 441
// module chunks = 1